import React, { useContext, useEffect, useState } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useForm } from "react-hook-form";
import * as ROUTES from "../constans/rutas";
import { useHistory } from "react-router-dom";
import Button from "react-bootstrap/Button";
import logo from "../asses/img/ponit.png";
import imagen from "../asses/img/contacto-azul@3x.png";
import AuthContex from "../context/autenticacion/authContex";

const MODULE_PERMISSIONS = {
  "nathalia.uribe@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/EthicsChannel",
  ],
  "marcela.suarez@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/EthicsChannel",
  ],
  "diana.pineros@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/EthicsChannel",
  ],
  "darwin.quintero@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/creditNotes",
    "/EthicsChannel",
    "/Pending",
    "/boleta",
    "/invoiceSupportDoc",
    "/PDF",
  ],
  "lency.camacho@parking.net.co": ["/Pending", "/boleta", "/PDF"],
  "elkin.barrero@parking.net.co": [
    "/Pending",
    "/boleta",
    "/invoiceSupportDoc",
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/EthicsChannel",
  ],
  "contabilidad@parking.net.co": ["/invoiceSupportDoc"],
  "contabilidad.impuestos@parking.net.co": ["/invoiceSupportDoc"],
  "contabilidad.arriendos@parking.net.co": [
    "/invoiceSupportDoc",
    "/creditNotes",
  ],
  "claudia.daleman@parking.net.co": ["/invoiceSupportDoc"],
  "elizabeth.moncada@parking.net.co": [
    "/Desenganche",
    "/Mensualidades",
    "/Convenios",
    "/creditNotes",
    "/Pending",
    "/boleta",
    "/PDF",
  ],
  "sandra.rodriguez@parking.net.co": [
    "/Desenganche",
    "/creditNotes",
    "/Mensualidades",
    "/Convenios",
    "/Pending",
    "/boleta",
    "/PDF",
  ],
  "sandra.acosta@parking.net.co": ["/Desenganche", "/creditNotes"],
  "claudia.guerrero@parking.net.co": ["/Desenganche"],
  default: ["/Desenganche", "/Mensualidades", "/Convenios"],
};

const HomePrincipalPage = () => {
  const history = useHistory();
  const authContex = useContext(AuthContex);
  const { usuario, usuarioAutenticado, cerrarSesion } = authContex;

  const [loading, setLoading] = useState(true);
  const [accessibleRoutes, setAccessibleRoutes] = useState([]);

  useEffect(() => {
    const fetchUserData = async () => {
      await usuarioAutenticado();
      const userEmail = usuario ? usuario.email : "default";
      setAccessibleRoutes(
        MODULE_PERMISSIONS[userEmail] || MODULE_PERMISSIONS["default"]
      );
      setLoading(false);
    };

    if (!usuario) {
      fetchUserData();
    } else {
      const userEmail = usuario.email;
      setAccessibleRoutes(
        MODULE_PERMISSIONS[userEmail] || MODULE_PERMISSIONS["default"]
      );
      setLoading(false);
    }
  }, [usuarioAutenticado]);

  if (loading) {
    return <div className="container-sniper"></div>;
  }

  if (!usuario) {
    return <div className="container-sniper"></div>;
  }

  return (
    <>
      <div className="conntent">
        <div className="conntent_">
          <Row>
            <Col className="ContModulos" xs={12} sm={12} md={6} lg={6} xl={6}>
              <h1 className="texto-titulo">{usuario.nombre}</h1>

              <img src={logo} alt="Logo" />

              {accessibleRoutes.includes("/Desenganche") && (
                <button
                  onClick={() => history.push("/Desenganche")}
                  className="buttom"
                >
                  Desenganche
                </button>
              )}
              {accessibleRoutes.includes("/PDF") && (
                <button onClick={() => history.push("/PDF")} className="buttom">
                  Factura Electrónica
                </button>
              )}

              {accessibleRoutes.includes("/creditNotes") && (
                <button
                  onClick={() => history.push("/creditNotes")}
                  className="buttom"
                >
                  Nota Crédito
                </button>
              )}

              {accessibleRoutes.includes("/Mensualidades") && (
                <button
                  onClick={() => history.push("/Mensualidades")}
                  className="buttom"
                >
                  Mensualidades
                </button>
              )}

              {accessibleRoutes.includes("/Convenios") && (
                <button
                  onClick={() => history.push("/Convenios")}
                  className="buttom"
                >
                  Convenios
                </button>
              )}

              {accessibleRoutes.includes("/Pending") && (
                <button
                  onClick={() => history.push("/Pending")}
                  className="buttom"
                >
                  Facturas Juridicas
                </button>
              )}

              {accessibleRoutes.includes("/boleta") && (
                <button
                  onClick={() => history.push("/boleta")}
                  className="buttom"
                >
                  Facturas Punto Servicio
                </button>
              )}

              {accessibleRoutes.includes("/invoiceSupportDoc") && (
                <button
                  onClick={() => history.push("/supportdoc")}
                  className="buttom"
                >
                  Facturas Documento Soporte
                </button>
              )}

              {accessibleRoutes.includes("/EthicsChannel") && (
                <button
                  onClick={() => history.push("/EthicsChannel")}
                  className="buttom"
                >
                  Canal de etica
                </button>
              )}
            </Col>
            <Col className="ContImagen" xs={12} sm={12} md={6} lg={6} xl={6}>
              <img className="imagen" src={imagen} alt="Centro de Apoyo" />
              <h1>Centro de Apoyo</h1>
              <div>
                <Button
                  style={{ marginRight: "10px" }}
                  variant="primary"
                  onClick={() => history.push(ROUTES.REGISTRO)}
                >
                  Crear Usuario
                </Button>
                <Button variant="primary" onClick={() => cerrarSesion()}>
                  cerrar sesion
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default HomePrincipalPage;
